module.exports = __webpack_public_path__ + "img/FR18610.11568f1c.png";